import {
  GetCollaboratorsCmSheetNotesResponse,
  UpdateCollaboratorsCmSheetNotesRequest,
} from "../../../types/api/collaborators.type";
import httpClient from "../../client/HttpClient";

const CmSheetNotesService = {
  async list(cmSheetId: number): Promise<GetCollaboratorsCmSheetNotesResponse> {
    const response = await httpClient.get<GetCollaboratorsCmSheetNotesResponse>(
      `v1/cm-sheets/${cmSheetId}/notes`,
    );
    return response;
  },
  async update(
    cmSheetId: number,
    body: UpdateCollaboratorsCmSheetNotesRequest,
  ): Promise<void> {
    await httpClient.patch(`v1/cm-sheets/${cmSheetId}/notes`, body);
  },
};

export default CmSheetNotesService;
